module.exports = __webpack_public_path__ + "img/budget-icon-blue.651968c0.svg";